

document.addEventListener('DOMContentLoaded', function() {
    
    document.querySelectorAll('a[data-cart-page="true"]').forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('[Cart Page Remove] Click detected:', link);

        const bundleId = link.dataset.bundleId;
        let updates = {};

        if (bundleId) {
          
          document.querySelectorAll(`a[data-bundle-id="${bundleId}"]`).forEach(l => {
            const href = l.getAttribute('href');
            const match = href.match(/id=([^&]+)&quantity=(\d+)/);
            if (match) {
              const lineKey = match[1];
              updates[lineKey] = 0; 
              console.log('[Cart Page Remove] Adding to updates:', lineKey);
            }
          });
        } else {
          
          const href = link.getAttribute('href');
          const match = href.match(/id=([^&]+)&quantity=(\d+)/);
          if (match) {
            updates[match[1]] = 0;
            console.log('[Cart Page Remove] Single item update:', match[1]);
          }
        }

        if (Object.keys(updates).length === 0) {
          console.warn('[Cart Page Remove] No items found to remove');
          return;
        }

        console.log('[Cart Page Remove] Sending POST to /cart/update.js with:', updates);

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ updates })
        })
        .then(response => response.json())
        .then(data => {
          console.log('[Cart Page Remove] Update result:', data);
          window.location.reload(); 
        })
        .catch(err => console.error('[Cart Page Remove] Error:', err));
      });
    });
  }, true);



// assets/custom-bundle-remove.js
(function () {
  
  document.addEventListener("DOMContentLoaded", () => {  
    const cartDrawer = document.querySelector("cart-drawer");
    cartDrawer.addEventListener("click", async (e) => {
      const removeLink = e.target.closest('a[data-bundle-id]');
      if (!removeLink) return;

      e.preventDefault();
      e.stopPropagation();

      const bundleId = removeLink.dataset.bundleId;
      console.log("[Bundle Remove] CLICK detected:", removeLink, "BundleId:", bundleId);

      console.log(location.pathname);
      const isCartPage = /(^|\/)cart(\/|$)/.test(location.pathname);
      const lineItems = isCartPage
        ? document.querySelectorAll('table.order-summary .line-item')
        : document.querySelectorAll('cart-drawer .line-item');
console.log(lineItems);
      const bundleItems = Array.from(lineItems).filter(li => {
        return li.dataset.bundleId === bundleId;
      });
console.log(bundleItems);
      if (bundleItems.length === 0) {
        console.warn("[Bundle Remove] No items found for bundleId:", bundleId);
        return;
      }

      console.log("[Bundle Remove] Keys to remove:", bundleItems);

      // Собираем line_key для AJAX
      const updates = {};
      bundleItems.forEach(item => {
        const lineKey = item.querySelector('[data-line-key]')?.dataset.lineKey;
        if (lineKey) updates[lineKey] = 0;
      });

      if (Object.keys(updates).length === 0) {
        console.warn("[Bundle Remove] No line_keys found, cannot remove bundle");
        return;
      }

      bundleItems.forEach(item => {
        const loader = item.querySelector('pill-loader');
        if (loader) {
          loader.setAttribute('aria-busy', 'true'); 
        }
      });

      try {                
        console.log("[Bundle Remove] Sending update.js payload:", updates);
        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates })
        });
        const data = await response.json();
        console.log("[Bundle Remove] update result:", data);

        if(isCartPage) {
          window.location.reload();
        } else {
          const event = new CustomEvent("cart:refresh");
          document.dispatchEvent(event);
        }
      } catch (err) {
        console.error("[Bundle Remove] Failed:", err);
      }

      bundleItems.forEach(item => {
        const loader = item.querySelector('pill-loader');
        if (loader) {
          loader.setAttribute('aria-busy', 'true'); 
        }
      });
    });
  }, true);


})();

